import {
  getCompaniesForEstimates,
  getRemoteEstimates,
} from '../../store/utils';
import { currentMoveCreated } from './currentMove';

const initCompaniesForEstimates = companiesForEstimates => ({
  type: 'INIT_COMPANIES_FOR_ESTIMATES',
  companiesForEstimates,
  companiesForEstimatesLoaded: true,
});

const _requestCompaniesForEstimates = dispatch => {
  currentMoveCreated().then(() => {
    getCompaniesForEstimates()
      .then(comps => {
        dispatch(initCompaniesForEstimates(comps));
      })
      .catch(ex => {
        dispatch(initCompaniesForEstimates([]));
        throw ex;
      });
  });
};

export const requestCompaniesForEstimates = () => _requestCompaniesForEstimates;

const updateRemoteEstimates = remoteEstimates => ({
  type: 'UPDATE_REMOTE_ESTIMATES',
  remoteEstimates,
});

const _requestRemoteEstimates = dispatch => {
  currentMoveCreated().then(() => {
    getRemoteEstimates(undefined, { isNetworkOnly: true }).then(estimates => {
      dispatch(updateRemoteEstimates(estimates));
    });
  });
};

export const requestRemoteEstimates = () => _requestRemoteEstimates;
